module.exports = __webpack_public_path__ + "static/img/20.0e397a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/20.png
// module id = XxKu
// module chunks = 2